import React from 'react';
import { Navigate } from 'react-router-dom';
import { usePermission } from '../pages/authentication/permission-providor/UserPermission';

const EditorRoute = ({ children }) => {
  const { isEditor, loading } = usePermission();

  if (loading) return null;
  
  return isEditor ? children : <Navigate to={`/space`} />;
};

export default EditorRoute;